export default "__VITE_ASSET__CYGkkMLr__"